"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var React = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _routeErrorDetail = _interopRequireDefault(require("web/shared/utils/routeErrorDetail"));
var _RouteErrorPage = require("web/shared/components/RouteErrorPage.styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* Client-side error boundary for a product's SPA: react-router renders this
* when a route throws (a render error, or an in-app navigation to a route
* the SPA does not define). It is a safety net *inside* the app — unknown
* top-level URLs are handled server-side, not here.
*/
function RouteErrorPage(props) {
  const error = (0, _reactRouterDom.useRouteError)(); // Surface the underlying error for debugging without crashing the page.
  console.error(error);
  const detail = (0, _routeErrorDetail.default)(error);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_RouteErrorPage.styles.wrapper)), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_RouteErrorPage.styles.title)), {}, {
      children: "Oops!"
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_RouteErrorPage.styles.message)), {}, {
      children: detail
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, (0, _objectSpread2.default)((0, _objectSpread2.default)({
      to: "/"
    }, stylex.props(_RouteErrorPage.styles.homeLink)), {}, {
      children: props.homeLinkLabel
    }))]
  }));
}
var _default = exports.default = RouteErrorPage;